"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function Rotate(e, t) {
  function o(e) {
    function t() {
      var t = "-200deg",
          o = "center";
      return e && n ? ((l || a) && u && (t = "-45deg"), ((l || a) && p || (s || i) && u) && (t = "45deg"), (s || i) && p && (t = "-90deg"), (p || u) && (o = (u ? "left" : "right") + " bottom")) : ((s || i) && p && (t = "-45deg"), ((s || i) && u || (l || a) && p) && (t = "45deg"), (l || a) && u && (t = "-90deg"), (p || u) && (o = (p ? "left" : "right") + " bottom")), (0, _globals.animation)("\n        " + (e ? "to" : "from") + " { opacity: 0; transform-origin: " + o + "; transform: rotate3d(0, 0, 1, " + t + ");}\n        " + (e ? "from" : "to") + " { opacity: 1; transform-origin: " + o + "; transform: none;}\n      ");
    }

    return {
      make: t
    };
  }

  var r = e.out,
      p = e.left,
      u = e.right,
      i = e.top,
      a = e.bottom,
      l = e.up,
      s = e.down,
      n = e.opposite,
      _ = (0, _objectWithoutProperties3.default)(e, ["out", "left", "right", "top", "bottom", "up", "down", "opposite"]);

  return t ? _react2.default.createElement(_Reveal2.default, (0, _extends3.default)({}, _, {
    in: o(!1),
    out: o(!0)
  })) : o(r);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties"),
    _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _Reveal = require("./Reveal"),
    _Reveal2 = _interopRequireDefault(_Reveal),
    _globals = require("./globals"),
    propTypes = {
  out: _propTypes.bool,
  left: _propTypes.bool,
  right: _propTypes.bool,
  top: _propTypes.bool,
  bottom: _propTypes.bool,
  opposite: _propTypes.bool
},
    defaultProps = {};

Rotate.propTypes = propTypes, Rotate.defaultProps = defaultProps, exports.default = Rotate, module.exports = exports.default;